import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { YouTubeVideo } from './component-youtube';
import { VimeoVideo } from './component-vimeo';
import ComponentVideo from './component-video';

class ParagraphMedia extends Component {

  render() {
    const sectionClassNames = classNames({
        'paragraph paragraph-media': true,
        'container': true
      }),
      { content } = this.props;

    switch (content.fieldMediaArt) {
      case 'youtube':
        return <YouTubeVideo content={content} sectionClassNames={sectionClassNames} />;
      case 'vimeo':
        return <VimeoVideo content={content} sectionClassNames={sectionClassNames} />;
      case 'video_file':
        return <ComponentVideo content={content} sectionClassNames={sectionClassNames} />;
      default:
        return false;
    }
  }
}

ParagraphMedia.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphMedia;
